import React from 'react';
import '../pageWelcome.css';
import './pageTechnicalInfoSelfcare360.css';
import AutoSizeTitle from '../../components/autoSizeTitle/AutoSizeTitle';
import { Typography } from 'antd';

const { Title } = Typography;

const DEFAULT_DIMENSIONS = [
    'Aprendizaje de incidentes',
    'Cumplimiento de reglas',
    'Liderazgo operativo',
    'Planeación segura',
    'Participación del equipo',
    'Stop work authority',
    'Controles críticos',
    'Gestión de fatiga',
];

const PageTechnicalInfoSelfcare360 = ({ selectedEvaluation, pageNumber, evaluatedDimensions }) => {
    const backgroundStyle = {
        backgroundImage: `url('/informs/pagina.png')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left top',
        backgroundSize: '100% auto',
    };

    const dimensions = Array.isArray(evaluatedDimensions) && evaluatedDimensions.length > 0
        ? evaluatedDimensions
        : DEFAULT_DIMENSIONS;

    return (
        <div className="pdf-page internal-page">
            <div className="internal-page-content" style={backgroundStyle}>
                <AutoSizeTitle text={selectedEvaluation.evl_title} />

                <div className="internal-page-info internal-page-info-individual">
                    <div className='welcome-page-text selfcare360-technical-text'>
                        <Title level={5} style={{ color: '#339C98', marginBottom: 8 }}>
                            Ficha técnica del instrumento
                        </Title>

                        <b>¿Qué es?</b> Assessment 360° de conductas observables de liderazgo en seguridad, diseñado para generar un índice predictivo de exposición al riesgo en supervisores operativos. Funciona como indicador líder (leading indicator) complementario a métricas rezagadas como TRIR o accidentalidad.
                        <br /><br />

                        <b style={{ color: '#339C98' }}>¿Qué mide?</b>
                        <ul>
                            {dimensions.map((d) => (
                                <li key={d}>{d}</li>
                            ))}
                        </ul>

                        <b style={{ color: '#339C98' }}>¿Cómo se evalúa?</b>
                        <br />
                        Metodología 360° multifuente:
                        <br />
                        • Jefe – Pares – Colaboradores – Autoevaluación – Cliente interno
                        <br />
                        Respuestas anónimas ~38–40 ítems conductuales Escala 0–100
                        <br />
                        Semáforos Flexible
                        <br /><br />

                        <b style={{ color: '#339C98' }}>¿Cómo se calcula el resultado?</b>
                        <br />
                        IPRA – Índice Ponderado de Riesgo en Seguridad: (Índice predictivo de exposición al riesgo)
                        <br />
                        IPRA = Σ (puntaje * peso por dimensión)
                        <br />
                        Si una dimensión supera 50% de respuestas N/O, se excluye del IPRA individual y el cálculo se recalibra sobre las dimensiones válidas.
                        <br />
                        El informe también reporta el chequeo de consistencia entre ítems directos e inversos.
                        <br />
                        Interpretación:
                        <br />
                        • Bajo → mayor exposición al riesgo
                        <br />
                        • Alto → gestión preventiva consistente
                        <br />
                        No mide accidentes pasados; anticipa vulnerabilidad futura.
                        <br /><br />

                        <b style={{ color: '#339C98' }}>¿Requisitos de aplicación?</b>
                        <br />
                        Muestra recomendada por supervisor:
                        <br />
                        • 7–10 evaluadores – Mínimo aceptable: ≥5
                        <br />
                        Frecuencia recomendada: Cada 6 meses
                        <br /><br />

                        <b style={{ color: '#339C98' }}>¿Para qué se usa?</b>
                        <br />
                        ✓ Detectar brechas conductuales
                        <br />
                        ✓ Priorizar riesgos
                        <br />
                        ✓ Definir planes de acción (90 días)
                        <br />
                        ✓ Desarrollar liderazgo seguro
                        <br /><br />

                        No sustituye auditorías técnicas ni indicadores de accidentalidad.
                    </div>
                </div>

                <div className="internal-page-number">{pageNumber}</div>
            </div>
        </div>
    );
};

export default PageTechnicalInfoSelfcare360;
